(function () {
  'use strict';

  /* ── Smooth inertia scroll (desktop only, wheel-driven) ── */
  function initSmoothScroll() {
    // Touch / pointer-only devices get native momentum — don't interfere
    if (window.matchMedia('(hover: none)').matches) return;

    var pos = window.scrollY;
    var vel = 0;
    var raf = null;

    function maxScroll() { return document.body.scrollHeight - window.innerHeight; }

    function step() {
      vel *= 0.89;                                   // friction — higher = more glide
      pos = Math.max(0, Math.min(pos + vel, maxScroll()));
      window.scrollTo(0, pos);
      if (Math.abs(vel) > 0.25) {
        raf = requestAnimationFrame(step);
      } else {
        raf = null;
      }
    }

    window.addEventListener('wheel', function (e) {
      // Let horizontal-dominant scrolls (trackpad swipe) pass through
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;

      // Don't intercept wheel over horizontally scrollable elements (e.g. sliders)
      var node = e.target;
      while (node && node !== document.body) {
        var cs = getComputedStyle(node);
        if (node.scrollWidth > node.clientWidth + 2 &&
            (cs.overflowX === 'auto' || cs.overflowX === 'scroll')) return;
        node = node.parentElement;
      }

      e.preventDefault();
      pos = window.scrollY;
      // Normalise across deltaMode: 0=px, 1=lines, 2=pages
      var delta = e.deltaMode === 1 ? e.deltaY * 32
                : e.deltaMode === 2 ? e.deltaY * window.innerHeight
                : e.deltaY;
      vel += delta * 0.28;
      if (!raf) raf = requestAnimationFrame(step);
    }, { passive: false });

    // Re-sync after non-wheel navigations (keyboard, scrollbar drag, anchor clicks)
    window.addEventListener('scroll', function () {
      if (!raf) pos = window.scrollY;
    }, { passive: true });
  }

  /* ── Reading progress bar ── */
  function initProgress() {
    var bar = document.createElement('div');
    bar.id = 'woc-progress';
    document.body.appendChild(bar);
    window.addEventListener('scroll', function () {
      var max = document.body.scrollHeight - window.innerHeight;
      if (max <= 0) return;
      bar.style.transform = 'scaleX(' + (window.scrollY / max) + ')';
    }, { passive: true });
  }

  /* ── Scroll reveal ── */
  function initReveal() {
    var sections = document.querySelectorAll('.shopify-section');
    sections.forEach(function (sec) {
      if (sec.closest('header') || sec.id === 'shopify-section-header' ||
          sec.id === 'shopify-section-announcement-bar' || sec.querySelector('.banner')) return;
      sec.classList.add('woc-reveal');
    });
    var gridItems = document.querySelectorAll('.hp-cats__item, .card-wrapper, .multicolumn-card, .collection-list__item');
    gridItems.forEach(function (el, i) {
      el.classList.add('woc-reveal-child');
      el.style.transitionDelay = (i % 6) * 85 + 'ms';
    });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('woc-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.07, rootMargin: '0px 0px -60px 0px' });
    document.querySelectorAll('.woc-reveal, .woc-reveal-child').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── Hero heading: force line break after "Heritage." ── */
  function fixHeroHeading() {
    var heading = document.querySelector('.banner__content .banner__heading');
    if (!heading) return;
    var html = heading.innerHTML;
    if (html.indexOf('Heritage.') !== -1 && html.indexOf('<br>') === -1) {
      heading.innerHTML = html.replace('Heritage. Made', 'Heritage.<br>Made');
    }
  }

  /* ── Hero entrance — called after preloader exits ── */
  function initHeroEntrance() {
    var items = document.querySelectorAll('.banner__content .banner__heading, .banner__content .banner__text, .banner__content .banner__buttons');
    if (!items.length) return;
    items.forEach(function (el, i) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(28px)';
      el.style.transition = 'opacity 900ms cubic-bezier(0.16,1,0.3,1), transform 900ms cubic-bezier(0.16,1,0.3,1)';
      el.style.transitionDelay = (i * 180) + 'ms';
    });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        items.forEach(function (el) { el.style.opacity = '1'; el.style.transform = 'translateY(0)'; });
      });
    });
  }

  /* ── Hero parallax ── */
  function initParallax() {
    var heroBg = document.querySelector('.banner__media img, .banner__media video');
    if (!heroBg) return;
    window.addEventListener('scroll', function () {
      heroBg.style.transform = 'translateY(' + (window.scrollY * 0.28) + 'px) scale(1.08)';
    }, { passive: true });
  }


  /* ── Animated counters ── */
  function initCounters() {
    var els = document.querySelectorAll('[data-woc-count]');
    if (!els.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var target = parseInt(el.getAttribute('data-woc-count'), 10);
        var start = performance.now(); var dur = 1100;
        (function tick(now) {
          var p = Math.min((now - start) / dur, 1);
          el.textContent = Math.round((1 - Math.pow(1 - p, 3)) * target);
          if (p < 1) requestAnimationFrame(tick);
        })(start);
        obs.unobserve(el);
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ── Makers Story: sticky full-page slides + parallax ── */
  function initMakersStory() {
    var section = document.querySelector('.woc-ms');
    var panels = document.querySelectorAll('[data-woc-ms-panel]');
    if (!panels.length || !section) return;

    // Reveal each panel's content when it becomes the active slide (≥70% visible)
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('woc-ms--in');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.7 });
    panels.forEach(function (p) { obs.observe(p); });

    // Parallax: track scroll relative to section start, not panel rect
    // (sticky panels always report getBoundingClientRect().top = 0 while stuck)
    if (window.innerWidth < 750) return;
    var vh = window.innerHeight;
    window.addEventListener('scroll', function () {
      vh = window.innerHeight;
      var scrolledIntoSection = -(section.getBoundingClientRect().top);
      panels.forEach(function (panel, i) {
        var media = panel.querySelector('[data-woc-ms-media]');
        if (!media) return;
        // How far we've scrolled within this panel's "window" (0 = just entered, 1 = next panel taking over)
        var progress = (scrolledIntoSection - i * vh) / vh;
        progress = Math.max(0, Math.min(1, progress));
        // ±16% of vh travel, matching the CSS inset: -16% 0
        var translate = (progress - 0.5) * 0.32 * vh;
        media.style.transform = 'translateY(' + translate + 'px)';
      });
    }, { passive: true });
  }

  /* ── Page-load preloader (first visit only) ── */
  function initPreloader() {
    var pre = document.getElementById('woc-preloader');
    if (!pre) { initHeroEntrance(); return; }
    if (window.Shopify && window.Shopify.designMode) {
      pre.style.display = 'none'; initHeroEntrance(); return;
    }
    if (sessionStorage.getItem('woc-visited')) {
      pre.style.display = 'none'; initHeroEntrance(); return;
    }
    sessionStorage.setItem('woc-visited', '1');
    document.body.classList.add('woc-loading');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { pre.classList.add('woc-preloader--animate'); });
    });
    setTimeout(function () {
      pre.classList.add('woc-pl--exit');
      document.body.classList.remove('woc-loading');
      setTimeout(function () { pre.style.display = 'none'; initHeroEntrance(); }, 950);
    }, 1700);
  }


  /* ── Auto-sliding featured collection (infinite loop) ── */
  function initAutoSlider() {
    document.querySelectorAll('.featured-collection slider-component, .featured-collection .slider-component').forEach(function (sliderEl) {
      var nextBtn = sliderEl.querySelector('.slider-button--next');
      if (!nextBtn) return;

      function step() {
        var atEnd = nextBtn.hasAttribute('disabled') ||
                    nextBtn.getAttribute('aria-disabled') === 'true';
        if (atEnd) {
          var track = sliderEl.querySelector('ul.slider, [id^="Slider-"]');
          if (track) track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          nextBtn.click();
        }
      }

      var timer = setInterval(step, 3500);
      sliderEl.addEventListener('mouseenter', function () { clearInterval(timer); });
      sliderEl.addEventListener('mouseleave', function () {
        timer = setInterval(step, 3500);
      });
    });
  }


  /* ── Horizontal scroll section ── */
  function initHorizontalScroll() {
    var wraps = document.querySelectorAll('[data-woc-hs]');
    wraps.forEach(function (wrap) {
      var track = wrap.querySelector('[data-woc-hs-track]');
      var dotsWrap = wrap.querySelector('[data-woc-hs-dots]');
      var dots = wrap.querySelectorAll('[data-woc-hs-dot]');
      if (!track) return;

      // Mobile: no JS needed
      if (window.innerWidth < 750) return;

      var panels = track.querySelectorAll('.woc-hs-panel');
      var numPanels = panels.length;
      wrap.style.height = (numPanels * 100) + 'vh';

      var ticking = false;
      var lastActive = -1;

      function update() {
        var rect = wrap.getBoundingClientRect();
        var scrolled = -rect.top;
        var maxScroll = wrap.offsetHeight - window.innerHeight;
        var progress = Math.max(0, Math.min(1, scrolled / maxScroll));
        var maxTranslate = (numPanels - 1) * window.innerWidth;

        track.style.transform = 'translateX(' + (-progress * maxTranslate).toFixed(2) + 'px)';

        // Show/hide dots
        if (dotsWrap) {
          var inView = scrolled > -window.innerHeight && scrolled < maxScroll + window.innerHeight;
          dotsWrap.classList.toggle('woc-hs-dots--visible', inView && scrolled >= 0);
        }

        // Active dot
        var activeIndex = Math.min(numPanels - 1, Math.round(progress * (numPanels - 1)));
        if (activeIndex !== lastActive) {
          lastActive = activeIndex;
          dots.forEach(function (dot, i) {
            dot.classList.toggle('woc-hs-dot--active', i === activeIndex);
          });
        }
        ticking = false;
      }

      window.addEventListener('scroll', function () {
        if (!ticking) { requestAnimationFrame(update); ticking = true; }
      }, { passive: true });

      // Dot click → scroll to that panel
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = parseInt(dot.getAttribute('data-woc-hs-dot'), 10);
          var maxScroll = wrap.offsetHeight - window.innerHeight;
          var targetScroll = wrap.getBoundingClientRect().top + window.scrollY +
                             (idx / (numPanels - 1)) * maxScroll;
          window.scrollTo({ top: targetScroll, behavior: 'smooth' });
        });
      });

      update();
    });
  }

  /* ── Scroll-velocity marquee: speeds up when scrolling fast ── */
  function initScrollMarquee() {
    var track = document.querySelector('.woc-mq__track');
    if (!track) return;
    var lastY = window.scrollY;
    var dur = 36;
    window.addEventListener('scroll', function () {
      var delta = Math.abs(window.scrollY - lastY);
      lastY = window.scrollY;
      dur = dur * 0.82 + Math.max(10, 36 - delta * 0.9) * 0.18;
      track.style.animationDuration = dur.toFixed(1) + 's';
    }, { passive: true });
  }

  /* ── Text scramble reveal ── */
  function initTextScramble() {
    var pool = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789*#@&<>[]~';

    function scramble(el) {
      var original = el.textContent.trim();
      if (!original) return;
      el.setAttribute('aria-label', original);
      var duration = Math.min(1400, Math.max(700, original.length * 45));
      var start = null;

      function frame(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var out = '';
        for (var i = 0; i < original.length; i++) {
          var ch = original[i];
          if (ch === ' ') { out += ' '; continue; }
          var settled = progress > (i / original.length) * 0.82 + 0.08;
          out += settled ? ch : pool[Math.floor(Math.random() * pool.length)];
        }
        el.textContent = out;
        if (progress < 1) requestAnimationFrame(frame);
        else el.textContent = original;
      }
      requestAnimationFrame(frame);
    }

    var targets = document.querySelectorAll(
      '.woc-cb__title, .featured-collection .collection__title, ' +
      '.hp-cats__label, .woc-cb__eyebrow, .multicolumn .title'
    );
    if (!targets.length) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { scramble(e.target); obs.unobserve(e.target); }
      });
    }, { threshold: 0.55 });
    targets.forEach(function (el) { obs.observe(el); });
  }

  /* ── Product card image parallax ── */
  function initCardParallax() {
    if (window.innerWidth < 990) return;
    var cards = document.querySelectorAll('.card__media');
    if (!cards.length) return;
    window.addEventListener('scroll', function () {
      var vh = window.innerHeight;
      cards.forEach(function (card) {
        var rect = card.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var progress = (vh - rect.top) / (vh + rect.height);
        var shift = (progress - 0.5) * rect.height * 0.12;
        var img = card.querySelector('img');
        if (img) img.style.transform = 'translateY(' + shift + 'px) scale(1.08)';
      });
    }, { passive: true });
  }

  /* ── Section counter: "01 / 02" label that ticks as sections enter ── */
  function initSectionCounter() {
    var sections = document.querySelectorAll(
      '.shopify-section:not(#shopify-section-header):not(#shopify-section-announcement-bar)'
    );
    if (sections.length < 2) return;
    var counter = document.createElement('div');
    counter.id = 'woc-sec-counter';
    counter.innerHTML = '<span id="woc-sec-n">01</span><span class="woc-sec-div">/</span><span id="woc-sec-total">' +
      String(sections.length).padStart(2, '0') + '</span>';
    document.body.appendChild(counter);
    var total = sections.length;
    var numEl = document.getElementById('woc-sec-n');
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var idx = Array.prototype.indexOf.call(sections, e.target) + 1;
        numEl.textContent = String(idx).padStart(2, '0');
      });
    }, { threshold: 0.5 });
    sections.forEach(function (s) { obs.observe(s); });
  }

  /* ── Custom Lightbox ── */
  function initCustomLightbox() {
    // Modal gets moved to body by theme — wait for it
    var modal = document.querySelector('product-modal');
    if (!modal) return;
    // If already moved to body, use it; otherwise wait briefly
    function setup() {
      modal = document.querySelector('product-modal');
      if (!modal) return;

    // Inject prev/next arrows and counter
    var prev = document.createElement('button');
    prev.className = 'woc-lb-arrow woc-lb-arrow--prev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML = '&#8592;';

    var next = document.createElement('button');
    next.className = 'woc-lb-arrow woc-lb-arrow--next';
    next.setAttribute('aria-label', 'Next image');
    next.innerHTML = '&#8594;';

    var counter = document.createElement('div');
    counter.className = 'woc-lb-counter';

    modal.appendChild(prev);
    modal.appendChild(next);
    modal.appendChild(counter);

    var currentIndex = 0;

    // Collect only top-level media items (direct children of content, or first [data-media-id] per media)
    function getMediaItems() {
      var content = modal.querySelector('.product-media-modal__content');
      if (!content) return [];
      // Get unique media IDs to avoid duplicates (img + deferred-media both have data-media-id)
      var seen = {};
      var result = [];
      content.querySelectorAll('[data-media-id]').forEach(function(el) {
        var id = el.getAttribute('data-media-id');
        if (!seen[id]) {
          seen[id] = true;
          result.push(el);
        }
      });
      return result;
    }

    function goTo(index) {
      var items = getMediaItems();
      if (!items.length) return;
      index = (index + items.length) % items.length;
      currentIndex = index;

      // Show/hide via inline style (beats all CSS specificity)
      items.forEach(function(el, i) {
        el.style.setProperty('display', i === index ? 'block' : 'none', 'important');
      });

      counter.textContent = (index + 1) + ' / ' + items.length;

      // Force lazy image to load
      var img = items[index].tagName === 'IMG' ? items[index] : items[index].querySelector('img');
      if (img) {
        if (img.loading === 'lazy') img.loading = 'eager';
        img.style.transform = '';
      }
    }

    function getActiveIndex() { return currentIndex; }

    // Stop clicks on arrows from closing the modal (pointerup handler)
    [prev, next].forEach(function(btn) {
      btn.addEventListener('pointerup', function(e) { e.stopPropagation(); });
      btn.addEventListener('click', function(e) { e.stopPropagation(); });
    });

    prev.addEventListener('click', function() { goTo(getActiveIndex() - 1); });
    next.addEventListener('click', function() { goTo(getActiveIndex() + 1); });

    // Keyboard navigation
    document.addEventListener('keydown', function(e) {
      if (!modal.hasAttribute('open')) return;
      if (e.key === 'ArrowLeft')  goTo(getActiveIndex() - 1);
      if (e.key === 'ArrowRight') goTo(getActiveIndex() + 1);
    });

    // Touch swipe on the modal content
    var swipeStartX = 0, swipeStartY = 0;
    modal.addEventListener('touchstart', function(e) {
      swipeStartX = e.touches[0].clientX;
      swipeStartY = e.touches[0].clientY;
    }, { passive: true });

    modal.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - swipeStartX;
      var dy = e.changedTouches[0].clientY - swipeStartY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      if (dx < 0) goTo(getActiveIndex() + 1);
      else         goTo(getActiveIndex() - 1);
    }, { passive: true });

    // Watch for open attribute (modal uses open, not hidden)
    var observer = new MutationObserver(function() {
      var isOpen = modal.hasAttribute('open');
      if (isOpen) {
        // Find which item the theme marked active and sync our index
        var items = getMediaItems();
        var startIdx = 0;
        items.forEach(function(el, i) {
          if (el.classList.contains('active')) startIdx = i;
        });
        currentIndex = startIdx;

        // Hide all, show only the active one (inline important beats CSS)
        items.forEach(function(el, i) {
          el.style.setProperty('display', i === startIdx ? 'block' : 'none', 'important');
        });

        var show = items.length > 1;
        counter.textContent = (startIdx + 1) + ' / ' + items.length;
        prev.style.display = show ? '' : 'none';
        next.style.display = show ? '' : 'none';
        counter.style.display = show ? '' : 'none';
      } else {
        prev.style.display = 'none';
        next.style.display = 'none';
        counter.style.display = 'none';
        // Restore display when modal closes
        modal.querySelectorAll('[data-media-id]').forEach(function(el) {
          el.style.removeProperty('display');
        });
      }
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['open'] });

    // Initially hidden
    prev.style.display = 'none';
    next.style.display = 'none';
    counter.style.display = 'none';
    } // end setup()
    setTimeout(setup, 300);
  }

  /* ── Lightbox pan/zoom ── */
  function initLightboxPan() {
    // Watch for product-modal becoming active via MutationObserver
    var modal = document.querySelector('product-modal');
    if (!modal) return;

    var observer = new MutationObserver(function() {
      // Modal opens: attach pan to the active image
      var active = modal.querySelector('[data-media-id].active img, [data-media-id].active .media img');
      if (active && !active._panEnabled) enablePan(active);
    });
    observer.observe(modal, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }

  function enablePan(img) {
    if (img._panEnabled) return;
    img._panEnabled = true;

    var wrap = img.parentElement;
    wrap.style.overflow = 'hidden';
    wrap.style.cursor = 'grab';
    img.style.transformOrigin = 'center center';
    img.style.transition = 'transform 0ms';
    img.style.willChange = 'transform';

    var scale = 1, tx = 0, ty = 0;
    var dragging = false, startX, startY, startTx, startTy;

    // Constrain translation so image doesn't go out of bounds
    function clamp() {
      var maxTx = (wrap.clientWidth  * (scale - 1)) / 2;
      var maxTy = (wrap.clientHeight * (scale - 1)) / 2;
      tx = Math.max(-maxTx, Math.min(maxTx, tx));
      ty = Math.max(-maxTy, Math.min(maxTy, ty));
    }

    function applyTransform(animated) {
      clamp();
      img.style.transition = animated ? 'transform 240ms ease' : 'transform 0ms';
      img.style.transform = 'scale(' + scale + ') translate(' + (tx / scale) + 'px, ' + (ty / scale) + 'px)';
    }

    // Scroll to zoom
    wrap.addEventListener('wheel', function(e) {
      e.preventDefault();
      scale = Math.min(4, Math.max(1, scale + (e.deltaY < 0 ? 0.2 : -0.2)));
      if (scale === 1) { tx = 0; ty = 0; }
      applyTransform(false);
    }, { passive: false });

    // Double-click to toggle zoom
    wrap.addEventListener('dblclick', function() {
      scale = scale > 1 ? 1 : 2.5;
      if (scale === 1) { tx = 0; ty = 0; }
      applyTransform(true);
    });

    // Mouse drag
    wrap.addEventListener('mousedown', function(e) {
      if (scale === 1) return;
      dragging = true;
      startX = e.clientX; startY = e.clientY;
      startTx = tx; startTy = ty;
      wrap.style.cursor = 'grabbing';
      e.preventDefault();
    });

    document.addEventListener('mousemove', function(e) {
      if (!dragging) return;
      tx = startTx + (e.clientX - startX);
      ty = startTy + (e.clientY - startY);
      applyTransform(false);
    });

    document.addEventListener('mouseup', function() {
      if (!dragging) return;
      dragging = false;
      wrap.style.cursor = scale > 1 ? 'grab' : 'default';
    });

    // Touch pinch + pan
    var lastDist = 0;
    img.addEventListener('touchstart', function(e) {
      if (e.touches.length === 2) {
        lastDist = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
      } else if (e.touches.length === 1 && scale > 1) {
        startX = e.touches[0].clientX; startY = e.touches[0].clientY;
        startTx = tx; startTy = ty;
      }
    }, { passive: true });

    img.addEventListener('touchmove', function(e) {
      if (e.touches.length === 2) {
        var dist = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
        scale = Math.min(4, Math.max(1, scale * (dist / lastDist)));
        lastDist = dist;
        if (scale === 1) { tx = 0; ty = 0; }
        applyTransform(false);
        e.preventDefault();
      } else if (e.touches.length === 1 && scale > 1) {
        tx = startTx + (e.touches[0].clientX - startX);
        ty = startTy + (e.touches[0].clientY - startY);
        applyTransform(false);
        e.preventDefault();
      }
    }, { passive: false });
  }

  /* ── Product corner frame: inject bottom corners, dots, and wash ── */
  function initProductFrame() {
    var product = document.querySelector('[data-product]');
    if (!product) return;

    // Bottom corner arms
    ['bl', 'br'].forEach(function(pos) {
      var el = document.createElement('span');
      el.className = 'woc-product-frame-' + pos;
      el.setAttribute('aria-hidden', 'true');
      product.appendChild(el);
    });

    // Diamond dots at all 4 corners
    ['tl', 'tr', 'bl', 'br'].forEach(function(pos) {
      var dot = document.createElement('span');
      dot.className = 'woc-corner-dot woc-corner-dot--' + pos;
      dot.setAttribute('aria-hidden', 'true');
      product.appendChild(dot);
    });

    // Subtle background wash
    var wash = document.createElement('div');
    wash.className = 'woc-product-wash';
    wash.setAttribute('aria-hidden', 'true');
    product.insertBefore(wash, product.firstChild);
  }

  /* ── Boot ── */
  function boot() {
    fixHeroHeading();
    initProductFrame();
    initCustomLightbox();
    initLightboxPan();
    initSmoothScroll();
    initPreloader();
    initProgress();
    initReveal();
    initParallax();
    initCounters();
    initMakersStory();
    initAutoSlider();
    initHorizontalScroll();
    initScrollMarquee();
    initTextScramble();
    initCardParallax();
    initSectionCounter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
